import React from 'react';
import SoundsSettingItem from '@src/components/_layouts/Default/components/settings/notifications/SoundsSettingItem';
import OrdersNotificationsSettingsList
    from '@src/components/_layouts/Default/components/settings/notifications/OrdersNotificationsSettingsList';

const managerDashboardPermissions = ['users@is-manager', 'manager-dashboard@can-see-dashboard'];
const otherPermissions = [
    'users@is-manager',
    'manager-dashboard@can-see-dashboard',
    'users@is-production',
    'production-dashboard@can-see-dashboard',
    'orders@index',
    'order-products@index',
];

export default function SoundsSettings() {
    return <>
        <OrdersNotificationsSettingsList/>
        <SoundsSettingItem
                notificationName="new-order-comment"
                permissionsToDisplay={managerDashboardPermissions}
        />
        <SoundsSettingItem
                notificationName="new-order-product-comment"
                permissionsToDisplay={otherPermissions}
        />
    </>;
}
